<template>
    <iv-modal
        title="编辑指标管理的关键字"
        :width="width"
        :closable="false"
        v-model="sources.shown"
        @on-cancel="onCancel"
        @on-ok="asyncOK">
        <iv-tag v-for="(tag,index) in tagsList" :key="index" :name='tag' size="large" closable @on-close="handleClose">{{tag}}</iv-tag>
        <div class="addInput">
            <iv-input v-model="addVal" size="small" style="width:120px" @on-keyup.enter="handleAdd" />
            <iv-button size='small' type="primary" style="margin-left: 10px;" @click="handleAdd">添加</iv-button>
        </div>
    </iv-modal>
</template>
<script>
import Vue from 'vue';
export default {
     props: {
        width: {
            type: [String, Number],
            default: "373"
        },
        keyword:{
            type: String,
            default: ""
        },
        item:{
            type: Object,
            default:{}
        }
    },
     watch: {
        'item.show'(val){
            this.sources.shown = val;
        },
        'item.keyword': {
            handler(newVal, oldVal) {
                this.tagsList = newVal.split("`")
            },
            deep:true
        }
    },
     data(){
        return {
            // columns: columns(this),
            sources: { //双向绑定字段
                shown: false,
            },
            // exportLoading:true,
            is_export:"",
            tagsList:[],
            addVal:''
        }
    },
    methods: {
        handleAdd(){
          if(this.addVal.trim() == "") return
            this.tagsList.push(this.addVal)
            this.addVal = ''
        },
        handleClose (event, name) {
                const index = this.tagsList.indexOf(name);
                this.tagsList.splice(index, 1);
        },
        onCancel(){
            // this.sources.result = this.value;
            this.hide();
        },
        hide(){
            this.sources.shown = false;
            this.$emit('shown-changed', this.sources.shown)
        },
        asyncOK () {
            console.log(this.tagsList,'list', this.tagsList.join('`'))
            const params = {
                ...this.item,
                secondTargetId  : this.item.secondTargetId,
                keyword         : this.tagsList.join('`')
            }
            this.$emit('SaveKeyword', params)
            this. hide()
        },
    }
}
</script>
<style scoped>
.ivu-tag{
    margin: 5px;
}
.panelList{
    list-style:none;
    padding:18px 15px;
    font-size:14px;
    line-height: 28px;
}
.radio-button{
    font-size:15px;
    border-radius: 5px !important;
}
.addInput{
    margin: 5px;
    display: inline-block;
}
</style>
